export const textFieldData = [
  { label: 'Nhan đề', type: 'text', name: 'title', required: true },
  { label: 'Tác giả', type: 'text', name: 'author', required: true },
  { label: 'Nhà xuất bản', type: 'text', name: 'publisher', required: true },
  {
    label: 'Gói sách',
    type: 'checkbox',
    name: 'bookCollections',
    placeholder: 'Vui lòng chọn gói sách',
    required: false,
    options: [],
  },
  {
    label: 'Năm xuất bản',
    type: 'number',
    name: 'publishYear',
    required: true,
    min: 1000,
    max: 9999,
  },

  {
    label: 'Khoa/Viện',
    type: 'select',
    name: 'facultyUuid',
    required: true,
    search: true,
    placeholder: 'Vui lòng chọn khoa, viện',
    options: [],
  },
  { label: 'Học phần', type: 'text', name: 'subject', required: false },
  { label: 'ISBN', type: 'text', name: 'isbn', required: false },
  {
    label: 'Giá',
    type: 'number',
    name: 'price',
    required: false,
    min: 0,
    max: 999999999,
  },
  { label: 'Tóm tắt', type: 'text', name: 'description', required: false },
  {
    label: 'Thời gian mượn trả tối đa',
    type: 'number',
    name: 'timeOfBorrow',
    required: false,
    min: 1,
    max: 99999,
    placeholder: 'Nhập số giờ',
  },
  {
    label: 'Số lượng mượn trả tối đa',
    type: 'number',
    name: 'numOfBorrow',
    required: false,
    min: 1,
    max: 99999,
    placeholder: 'Nhập số lượt',
  },
]
